import { Option } from '../../types/option';

export const beautyServices: Option[] = [
  {
    label: 'Women\'s Cut',
    value: 'cutting_women'
  },
  {
    label: 'Women\'s Cut & Blow Dry',
    value: 'can_do_hair_up'
  },
  {
    label: 'hair down styles',
    value: 'can_do_hair_down'
  },
  {
    label: 'spray tans',
    value: 'spray_tans'
  },
  {
    label: 'nails',
    value: 'nails'
  },
  {
    label: 'facials',
    value: 'facials'
  },
];

export const otherServices: Option[] = [
  {
    label: 'yoga',
    value: 'yoga'
  },
  {
    label: 'massage',
    value: 'massage'
  },
  {
    label: 'photograph',
    value: 'photograph'
  },
  {
    label: 'cakes',
    value: 'cakes'
  },
  {
    label: 'art',
    value: 'art'
  },
]